import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TaskManagerOTPModal from "../task-manager/TaskManagerOTPModal";
import { Button, Card, Col, Row } from "react-bootstrap";
import InspectionRecords from "./InspectionRecords";
import TaskManagerRequest from "../../../services/TaskManagerRequest";
import FileSaver from "file-saver";
import { ShowNotification } from "../../../services/Notifications";
import { TASK_ASSETS_URL } from "../../../environments/environments";
import { getVehicleInspectionRecords } from "../../../store/actions/inspection.action";
import { updateVehicleStorage } from "../../../store/actions/setting.action";

const VehicleStorageTable = (props) => {
  const dispatch = useDispatch();
  const storage = useSelector((state) => state.settingReducer.vehiclesStorage);
  const [isLoading, setIsLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [storageUsed, setStorageUsed] = useState(false);
  const [vehicleStorage, setVehicleStorage] = useState(false);

  const handleDownloadFiles = async (module) => {
    try {
      const response = await TaskManagerRequest(
        "/storage/vehicle/download-files",
        { vehicle: props.activeVehicle, modules: [...module] },
        false,
        "download-files-locally"
      );
      if (response.zipPath) {
        const zipUrl = `${TASK_ASSETS_URL}/${response.zipPath}`;
        const parts = zipUrl.split(".");
        const ext = parts[parts.length - 1];
        FileSaver.saveAs(
          zipUrl,
          `${vehicleStorage?.vehicleName ?? "Locator"} Backup.` + ext
        );

        // await TaskManagerRequest("/storage/unlink-zip", response);
      }
    } catch (error) {
      ShowNotification("error", error);
    }
  };

  const fetchVehicleStorage = async () => {
    setIsLoading(true);
    setVehicleStorage(null);
    const response = await TaskManagerRequest("/storage/vehicle", {
      vehicle: props.activeVehicle,
    });
    setVehicleStorage(response);
    setIsLoading(false);
  };

  useEffect(() => {
    const parseStorage = () => {
      if (props.activeVehicle) {
        setStorageUsed((storage[props.activeVehicle] / 1048576).toFixed(2));
      } else if (props.storage?.vehicleStorage?.inspection != null) {
        setStorageUsed(
          (props.storage?.vehicleStorage?.inspection / 1048576).toFixed(2)
        );
      } else {
        setStorageUsed(0);
      }
    };

    parseStorage();
    if (props.activeVehicle) {
      fetchVehicleStorage();
    }
  }, [props.activeVehicle, storage]);

  const handleDelete = async (modules) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete the assets? This action cannot be reversed."
    );
    if (confirmed) {
      const response = await TaskManagerRequest(
        "/storage/vehicle/delete-files",
        {
          vehicle: props.activeVehicle ?? false,
          modules: [...modules],
        },
        false,
        "delete-files-vehicle"
      );
      dispatch(getVehicleInspectionRecords(null, props.activeVehicle ?? "all"));
      dispatch(updateVehicleStorage(response.storage));
      await props.loadStorage();
      alert(response.message);
    } else {
      // Cancelled
      alert("Deletion cancelled.");
    }
  };

  return (
    <>
      {props.activeVehicle && (
        <div
          style={{
            fontSize: "10px",
            backgroundColor: "#007bff20",
            color: "#004987",
          }}
          className="rounded p-2 m-1 d-flex align-items-center justify-content-between"
        >
          <p className="mb-0">
            {" "}
            {isLoading ? "Loading" : vehicleStorage?.vehicleName ?? "--"}
          </p>
          <p className="mb-0"> {isLoading ? "--" : `${storageUsed} GB used`}</p>
        </div>
      )}
      <div className="mx-2">
        {/* <Row className="row row-cols-2">
          <Col> */}
        <Card bg="light" border="primary" className="">
          <Card.Body>
            <section
              className="justify-content-between"
              style={{ display: "flex" }}
            >
              <section className="gap-5 d-flex">
                <div>
                  <Card.Img
                    variant="top"
                    src={
                      require("../../../assets/img/settings/inspection_active.png")
                        .default
                    }
                    className="mx-auto mt-4"
                    style={{ width: "50px" }}
                  />
                </div>
                <div>
                  <Card.Title className="text-md">Inspection</Card.Title>
                  <Card.Text className="semi-bold">
                    {props.activeVehicle ? (
                      <>
                        {(
                          (vehicleStorage?.inspection?.totalUsedStorage ?? 0) /
                          1048576
                        ).toFixed(2)}{" "}
                        GB Used /{" "}
                        {vehicleStorage?.inspection?.totalRecords ?? 0} Records
                        Found
                      </>
                    ) : (
                      <>{storageUsed} GB Used</>
                    )}
                  </Card.Text>
                  <div className="d-flex gap-2">
                    <Button
                      id="download-files-locally"
                      onClick={() => handleDownloadFiles(["inspection"])}
                      variant="primary text-xs"
                    >
                      <i
                        className="fa fa-download text-white"
                        aria-hidden="true"
                      ></i>
                      {"  "}
                      Download Files Locally
                    </Button>
                    <Button
                      id="delete-files-vehicle"
                      onClick={() => handleDelete(["inspection"])}
                      variant="danger text-xs"
                    >
                      <i
                        className="fa fa-trash text-white"
                        aria-hidden="true"
                      ></i>
                      {"  "}
                      Delete Assets
                    </Button>
                  </div>
                </div>
              </section>
              <div
                onClick={() => setIsExpanded((prev) => !prev)}
                className="d-flex align-items-center pointer justify-content-center"
              >
                <img
                  width="20"
                  height="20"
                  src={`https://img.icons8.com/ios-glyphs/25/chevron-${
                    isExpanded ? "up" : "down"
                  }.png`}
                  className="my-auto"
                  alt="chevron"
                />
              </div>
            </section>
            {isExpanded && (
              <InspectionRecords
                loadStorage={props.loadStorage}
                vehicle={props.activeVehicle}
              />
            )}
          </Card.Body>
        </Card>
        {/* </Col>
        </Row> */}
      </div>
    </>
  );
};

export default VehicleStorageTable;
